import { defineBlock } from "eddev/blocks"

export default defineBlock("accounts/signup-wizard", (props) => {
  return <div>Sign up form!</div>
})
